import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import ApiService from '../../../services/api.service';
const initialState = {
  defaultColors: [],
  status: false,
  error: null,
};
export const fetchDefaultColors = createAsyncThunk(
  'master/fetchDefaultColors',
  async (_, { getState, rejectWithValue }) => {
    const { defaultColors } = getState().defaultColors;
    if (defaultColors && defaultColors.length > 0) {
      return rejectWithValue('defaultColors already fetched');
    } else {
      const clientId = localStorage.getItem('client_id');
      const response = await ApiService.get(
        `/admin-config/color-code-config/${clientId}/color-config`
      );
      return response?.data;
    }
  }
);
const defaultColorSlice = createSlice({
  name: 'defaultColors',
  initialState,
  reducers: {
    clearDefaultColors: state => {
      state.defaultColors = [];
      state.status = false;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchDefaultColors.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchDefaultColors.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.defaultColors = action?.payload || [];
      })
      .addCase(fetchDefaultColors.rejected, (state, action) => {
        if (action.payload === 'defaultColors already fetched') {
          state.status = 'succeeded';
        } else {
          state.status = 'failed';
          state.error = action.error.message;
        }
      });
  },
});

export const { clearDefaultColors } = defaultColorSlice.actions;

export const defaultColorReducer = defaultColorSlice.reducer;
